import React from 'react';

/**
 * Returns `false` on the first paint and flips to `true` on mount (next frame).
 *
 * Drives the area's enter animations: progress bars / gauges first paint at
 * their empty state, then transition to their real value once this is `true`.
 */
export const useMountAnimation = (): boolean => {
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    const id = requestAnimationFrame(() => setMounted(true));
    return () => cancelAnimationFrame(id);
  }, []);

  return mounted;
};

export default useMountAnimation;